import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import Pill from '@vromo/ui/components/Pill';
import theme from '@vromo/ui/components/theme';
import Table from '@vromo/ui/components/Table';
import { AddButton } from '@vromo/dashboard/src/blueprints/BlueprintStyles';
import { Blueprint, TaskBlueprint } from '@vromo/models';
import { deserialize, update } from 'serializr';
import { runInAction } from 'mobx';

type Props = {
    isNew: boolean;
    blueprint: Blueprint;
};

export default observer(function BlueprintTaskSources({ isNew, blueprint }: Props) {
    const [showPickup, setShowPickup] = useState(
        () => isNew && blueprint.template.tasks.length === 0
    );
    const [showDropoff, setShowDropoff] = useState(
        () => isNew && blueprint.template.tasks.length === 0
    );

    function taskBlueprintList(source: number): Array<TaskBlueprint> {
        return [
            deserialize(TaskBlueprint, {
                offset: null,
                source: source,
                timeframe: 'source',
                constraints: ['manual'],
                zone: {
                    name: 'Arrive at {{task.address}}',
                    address: '{{task.address}}',
                    radius: 75,
                    type: 'arrival'
                }
            }),
            deserialize(TaskBlueprint, {
                offset: null,
                source: source,
                timeframe: 'source',
                constraints: ['manual'],
                zone: {
                    name: 'Depart from {{task.address}}',
                    address: '{{task.address}}',
                    radius: 75,
                    type: 'departure'
                }
            })
        ];
    }

    function setDefaultPickup() {
        runInAction(() => update(blueprint, {
            template: { tasks: blueprint.template.tasks.concat(taskBlueprintList(0)) }
        }));

        setShowPickup(false);
    }

    function setDefaultDropoff() {
        runInAction(() => update(blueprint, {
            template: { tasks: blueprint.template.tasks.concat(taskBlueprintList(1)) }
        }));

        setShowDropoff(false);
    }

    return (
        <Table style={{ flex: 1, marginBottom: 0 }}>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Parameters</th>
                    {isNew && <th>Actions</th>}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{`Pickup`}</td>
                    <td>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 1,
                                flexWrap: 'wrap'
                            }}>
                            <Pill
                                icon={'store-alt'}
                                description={'Pickup Name'}
                                color={theme.primary}
                            />
                            <Pill
                                icon={'store-alt'}
                                description={'Pickup Address'}
                                color={theme.primary}
                            />
                        </div>
                    </td>
                    {isNew && showPickup && (
                        <td>
                            <AddButton onClick={setDefaultPickup}>Create Output Tasks</AddButton>
                        </td>
                    )}
                </tr>
                <tr>
                    <td>{`Dropoff`}</td>
                    <td>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 1,
                                flexWrap: 'wrap'
                            }}>
                            <Pill icon="home" description={'Dropoff Name'} color={theme.primary} />
                            <Pill
                                icon="home"
                                description={'Dropoff Address'}
                                color={theme.primary}
                            />
                        </div>
                    </td>
                    <td>
                        {isNew && showDropoff && (
                            <AddButton onClick={setDefaultDropoff}>Create Output Tasks</AddButton>
                        )}
                    </td>
                </tr>
            </tbody>
        </Table>
    );
});
